import { render, staticRenderFns } from "./addStakeholder.vue?vue&type=template&id=3b4d112f&scoped=true&"
var script = {}
import style0 from "./addStakeholder.vue?vue&type=style&index=0&id=3b4d112f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d112f",
  null
  
)

export default component.exports